import * as Actions from './SessionDetailsActions';

const initialState = {
  fetching: false,
  fetchingAttendeesInSessionsOverTime: false,
  sessionDetails: null,
  attendeesInSessionInfoOverTime: {},
  stats: {
    attendees: 0,
    registrants: 0,
    averageInterestRating: 0,
    averageAttentiveness: 0,
    interestRating: 0
  },
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_SESSION_DETAILS_REQUEST: {
      return { ...state, ...initialState, fetching: true };
    }
    case Actions.GET_SESSION_DETAILS_SUCCESS: {
      const { sessionDetails } = action.payload;
      const { sessionStatsInfo = { ...initialState.stats } } = sessionDetails;
      return {
        ...state,
        sessionDetails,
        stats: {
          ...state.stats,
          attendees: sessionStatsInfo.attendeeCount,
          registrants: sessionStatsInfo.registrantCount,
          averageInterestRating: sessionStatsInfo.averageInterestRating,
          averageAttentiveness: sessionStatsInfo.averageAttentiveness,
          ...sessionStatsInfo
        },
        fetching: false,
        error: null
      };
    }
    case Actions.GET_SESSION_DETAILS_FAILURE: {
      return { ...state, error: action.error, fetching: false };
    }
    case Actions.GET_SESSION_DETAILS_ATTENDEE_COUNT_REQUEST: {
      return { ...state, fetchingAttendeesInSessionsOverTime: true };
    }
    case Actions.GET_SESSION_DETAILS_ATTENDEE_COUNT_SUCCESS: {
      const { sessionInfo } = action.payload.sessionAttendeeDetailsPerSession;
      let attendeesInSessionInfoOverTime = [];
      if (sessionInfo.attendeeCountsOverTime) {
        attendeesInSessionInfoOverTime.attendeeCountsOverTime = sessionInfo.attendeeCountsOverTime;
        attendeesInSessionInfoOverTime.timeZone = sessionInfo.timeZone;
      } else {
        attendeesInSessionInfoOverTime = [];
      }

      return {
        ...state,
        attendeesInSessionInfoOverTime: attendeesInSessionInfoOverTime,
        fetchingAttendeesInSessionsOverTime: false
      };
    }
    case Actions.GET_SESSION_DETAILS_ATTENDEE_COUNT_FAILURE: {
      return { ...state, error: action.error, fetchingAttendeesInSessionsOverTime: false };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/SessionDetails/SessionDetailsReducer.js